/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import API from '../../requests';
import FireboardUtils from '../../util/fireboard-util';
import { getPopupConfig } from '../../components/Popup';
import constants from '../../globalization';
import View from './views';
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import CommonUtil from '../Fireboard/common';
import { getPickerData } from "../../components/CountryPicker";
import UTILLib from "../../util";
import EventEmitter from '../../util/event-emitter';
import { LogLevelEnum, checkEnum } from '../../enums';
import { retryPOSPayment } from "../../store/actions";
import { TimeConstants } from '../../constants';
import { version } from '../../../package.json';

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

class OrderStatusManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: undefined,
      isCustomSmsType: true,
      customSmsList: [],
      selectedCountry: {},
      selectedCheck: {},
      sensorData: {},
      isDevEnvironment: false,
      fromFooter: false,
      pendingCheckList: [],
      comingUpCheckList: [],
      inProgressCheckList: [],
      completeCheckList: [],
      seeCounterCheckList: [],
      twoDimensionSlot: [[]],
      sortByTime: true,
    };
    this.checks = new Map();
    this.currency = this.props?.reduxProps?.currencyInfo?.currency || '$';
    this.countriesData = [];
    this.parentRoute = '';
    this.notifyOrderPrepared = {};
    this.notifyOrderReady = {};
    this.filteredChecks = [];
    this.activeCheckFilter = 'sourceType';
    this.checkSourceTypes = [];
    this.checkOrderTypes = [];
    this.checkRevenueTypes = [];
    this.checkSensorGroupTypes = [];
    this.cubbyLayoutPopupType = '';
    this.storeCubbySlotsMap = new Map();
    this.sensorsMap = new Map();
    this.enableAgeRestrictedOrderingForCheck = false;
    this.enableAgeVerification = false;
  }

  componentDidMount() {
    const { reduxProps, history } = this.props;
    const { storeInfo, deviceInfo } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};

    if (window.ReactNativeWebView) {
      EventEmitter.addLogs(
        'appLogs',
        LogLevelEnum.INFO,
        `Mounting Store Cubby component with storeId ${storeId} and deviceExternalId ${deviceInfo?.deviceExternalId}`
      );
    }

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 15 }
      });
      return;
    }

    this.getCustomSmsTemplates();

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      this.state.isDevEnvironment = true;
    }

    const { location } = history || {};
    const { state } = location || {};
    const { parentRoute } = state || {};
    this.parentRoute = parentRoute;

    this.countriesData = getPickerData();
    const countryCode = this.currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
    this.state.selectedCountry = this.countriesData.find(country => country.iso2 === countryCode);

    this.buildSensorsHashTable();
    this.setDeviceGroupData();

    const { context } = this.props;
    this.setChecks(context?.checks);

    if (window.ReactNativeWebView) {
      this.scanToRedeemListener = message => this.onVoucherScanned(message);
      EventEmitter.addListeners('onVoucherScanned', this.scanToRedeemListener);
    }

    this.startInterval();
  }

  componentWillUnmount() {
    if (window.ReactNativeWebView) {
      this.scanToRedeemListener && EventEmitter.removeListeners('onVoucherScanned', this.scanToRedeemListener);
    }
    this.stopInterval();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { reduxProps } = newProps;
    this.handleRetryPOSPayment(reduxProps);

    if (this.props?.context !== newProps?.context) {
      const { context: nextContext } = newProps;
      this.setChecks(nextContext?.checks, nextContext?.deletedChecks);
    }
  }

  setChecks = (checks, deletedChecks) => {
    let checksMap = new Map();
    const allChecks = Array.from(checks.values());
    allChecks && allChecks.forEach(check => {
      checksMap.set(check.id, CommonUtil.parseCheckFromRedis(check));
    });
    this.checks = checksMap;
    this.refreshChecks();
  };

  setDeviceGroupData = () => {
    const { reduxProps: { deviceApi, deviceApiData, storeInfo } } = this.props;
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
      const {
        fireBoardSettings,
        checkChannelFilters,
        checkOrderTypeFilters,
        checkRevenueCenterFilters,
        checkSensorGroupFilters,
      } = deviceGroup || {};
      this.activeCheckFilter = CommonUtil.getActiveFilterSourceFromDeviceGroup(fireBoardSettings);
      this.checkSourceTypes = CommonUtil.getODOrderTypes(checkChannelFilters);
      this.checkOrderTypes = CommonUtil.getPOSOrderTypes(checkOrderTypeFilters, storeInfo?.data?.orderTypes);
      this.checkRevenueTypes = CommonUtil.getRevenueCenterOrderTypes(checkRevenueCenterFilters, storeInfo?.data?.revenueCenters);
      this.checkSensorGroupTypes = CommonUtil.getSensorGroupOrderTypes(checkSensorGroupFilters, storeInfo?.data?.sensorGroups);
      this.enableAgeRestrictedOrderingForCheck = fireBoardSettings?.enableAgeRestrictedOrderingForCheck || false;
      this.enableAgeVerification = fireBoardSettings?.enableAgeVerification || false;
    } else {
      const { reduxProps } = this.props;
      const { storeTypesPersist } = reduxProps;
      const { activeCheckFilter, sourceTypes, orderTypes, revenueTypes, sensorGrpTypes } = storeTypesPersist?.data || {};
      this.activeCheckFilter = activeCheckFilter || 'sourceType';
      this.checkSourceTypes = sourceTypes || [];
      this.checkOrderTypes = orderTypes || [];
      this.checkRevenueTypes = revenueTypes || [];
      this.checkSensorGroupTypes = sensorGrpTypes || [];
    }
  };

  handleErrorPopup = (error) => {
    const errorMsg = error.response
      ? error.response.data
      : error.message;
    FireboardUtils.addNetworkLogs(error.response);
    this.getPopup("error", null, errorMsg);
  };

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  showPopup = (type, data) => {
    switch (type) {
      case 'check-actions':
        const check = data || {};
        this.setState({ popup: { type }, selectedCheck: check });
        break;
      case 'sms':
      case 'repostpayment':
      case 'redeemCheckVoucher':
      case 'viewOnMap':
      case 'updateGuestInformation':
        this.setState({ popup: { type } });
        break;
      default:
        console.warn(`popup type - ${type} not handled!!!`);
        break;
    }
  };

  closePopup = () => {
    this.setState({ popup: undefined });
  };

  goBack = () => {
    const { history } = this.props;
    history && history.goBack();
  };

  startInterval = () => {
    this.stopInterval();
    this.interval = setInterval(() => {
      this.refreshChecks();
    }, 60 * 1000);
  };

  stopInterval = () => {
    this.interval && clearInterval(this.interval);
    this.interval = null;
  };

  getFilteredChecks = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const checks = Array.from(this.checks.values());
    const filters = {
      data: {
        orderTypes: this.checkOrderTypes,
        sourceTypes: this.checkSourceTypes,
        revenueTypes: this.checkRevenueTypes,
        sensorGroupTypes: this.checkSensorGroupTypes,
        activeCheckFilter: this.activeCheckFilter,
      }
    };
    const allChecks = CommonUtil.getAllSelectedChecks(checks, filters, storeInfo, this.sensorsMap);
    //should not display voided checks
    const filteredCheckList = allChecks.filter(check => {
      const { orders } = check;
      const [order0] = orders || [];
      if (check?.void === true || orders?.length === 0 || order0?.orderStatusId === 10)
        return false;
      return true;
    });
    return filteredCheckList;
  };

  refreshChecks = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { storeCubby } = storeInfo?.data || {};
    this.storeCubbySlotsMap = FireboardUtils.buildStoreCubbyHashTable(storeCubby);
    this.filteredChecks = this.getFilteredChecks();
    const checks = this.getFormattedChecks;
    const twoDimensionSlot = FireboardUtils.getCubbySlotsData(storeCubby, checks);
    this.state.twoDimensionSlot = twoDimensionSlot;
    this.refreshSectionChecks(checks);
  };

  refreshSectionChecks = checks => {
    let pendingCheckList = [];
    let comingUpCheckList = [];
    let inProgressCheckList = [];
    let completeCheckList = [];
    let seeCounterCheckList = [];

    checks && checks.forEach(check => {
      const { orders, sendDate } = check;
      const { comingUpTime, prepTime, warningTime, errorTime, clearTime } = this.cutoffTimeCalculation(check);
      const [order0] = orders || [];
      const { pickUpStatus, pickupDate, orderStatusId } = order0 || {};
      const currentTime = new Date().getTime();
      const pickupTime = this.getTimeInMilliSeconds(pickupDate);
      let isPending = false;
      let isComingUp = false;
      let isInProgress = false;
      let isComplete = false;
      let isSeeCounter = false;
      if ((orderStatusId === 0) || (orderStatusId === 1 && currentTime < comingUpTime && !sendDate)) {
        isPending = true;
      } else if ((orderStatusId === 0 || orderStatusId === 1) && comingUpTime < currentTime && currentTime < prepTime && !sendDate) {
        isComingUp = true;
      } else if (orderStatusId === 1) {
        isInProgress = true;
      } else if (orderStatusId === 5 && pickUpStatus === 0) {
        isComplete = true;
        if (clearTime && currentTime > clearTime) {
          isComplete = false;
        }
      } else if (orderStatusId === 5 && pickUpStatus === 3) {
        isSeeCounter = true;
      }

      //color coding
      let color;
      if (isPending) {
        if (orderStatusId === 0 && comingUpTime < currentTime && comingUpTime < prepTime)
          color = 'orange';
        else if (orderStatusId === 0 && currentTime > prepTime)
          color = 'red';
        pendingCheckList.push({ ...check, color });
      } else if (isComingUp) {
        comingUpCheckList.push({ ...check, color });
      } else if (isInProgress) {
        if (currentTime > pickupTime)
          color = 'red';
        inProgressCheckList.push({ ...check, color });
      } else if (isComplete) {
        if (warningTime && errorTime && currentTime > warningTime && currentTime < errorTime)
          color = 'orange';
        else if (errorTime && currentTime > errorTime)
          color = 'red';
        completeCheckList.push({ ...check, color });
      } else if (isSeeCounter) {
        if (warningTime && errorTime && currentTime > warningTime && currentTime < errorTime)
          color = 'orange';
        else if (errorTime && currentTime > errorTime)
          color = 'red';
        seeCounterCheckList.push({ ...check, color });
      }
    });

    this.setState({
      pendingCheckList,
      comingUpCheckList,
      inProgressCheckList,
      completeCheckList,
      seeCounterCheckList,
    });
  };

  cutoffTimeCalculation = check => {
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { prepWindow } = storeInfo?.data || {}; //prepWindow is in minutes
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};
    const { orders } = check || {};
    const [order0] = orders || [];
    const { pickupDate, orderDate } = order0 || {};
    const dueDate = pickupDate || orderDate;
    const comingUpTime = this.getComingUpTime(dueDate, prepWindow);
    const prepTime = this.getPrepTime(dueDate, prepWindow);
    let warningTime = null;
    let errorTime = null;
    let clearTime = null;
    if (deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
      const { orderUpWarningTime, orderUpErrorTime, orderUpClearTime } = deviceGroup || {}; //time is in seconds
      if (orderUpWarningTime)
        warningTime = this.getWarningOrErrorOrClearTime(dueDate, orderUpWarningTime);
      if (orderUpErrorTime)
        errorTime = this.getWarningOrErrorOrClearTime(dueDate, orderUpErrorTime);
      if (orderUpClearTime)
        clearTime = this.getWarningOrErrorOrClearTime(dueDate, orderUpClearTime);
    }
    return {
      comingUpTime,
      prepTime,
      warningTime,
      errorTime,
      clearTime,
    };
  };

  getComingUpTime = (dueDate, prepWindow) => {
    const dueTime = this.getTimeInMilliSeconds(dueDate);
    const comingUpTime = dueTime - (2 * prepWindow * 60 * 1000);
    return comingUpTime;
  };

  getPrepTime = (dueDate, prepWindow) => {
    const dueTime = this.getTimeInMilliSeconds(dueDate);
    const prepTime = dueTime - (prepWindow * 60 * 1000);
    return prepTime;
  };

  getWarningOrErrorOrClearTime = (dueDate, orderUpTime) => {
    const dueTime = this.getTimeInMilliSeconds(dueDate);
    const time = dueTime + (orderUpTime * TimeConstants.SECOND);
    return time;
  };

  getTimeInMilliSeconds = (date) => {
    if (!date) return 0;
    let convertedDate;
    if (date && date.includes('Z'))
      convertedDate = new Date(date);
    else
      convertedDate = new Date(date + 'Z');
    const timeInMS = convertedDate.getTime();
    return timeInMS;
  };

  get getFormattedChecks() {
    const { reduxProps: { currencyInfo } } = this.props;
    const { iso2 } = currencyInfo || {};
    const formattedChecks = this.filteredChecks.map(check => {
      const [order0] = check?.orders || [];
      const { storeCubbySlotId, sendDate, pickupDate } = order0 || {};
      const slot = this.storeCubbySlotsMap.has(storeCubbySlotId) ? this.storeCubbySlotsMap.get(storeCubbySlotId) : {};
      const slotName = slot?.name || '';
      return {
        checkNumber: check.checkNumber,
        number: check.number,
        id: check.id,
        checkHeaderId: check.checkHeaderId,
        deliverTo: FireboardUtils.getDeliverTo(check),
        sourceType: check.sourceType,
        phoneNumber: check.phoneNumber ? FireboardUtils.formattedPhoneNumber(check.phoneNumber, iso2) : "- -",
        unFormattedPhoneNumber: check.phoneNumber,
        orderStatusId: check.orderStatusId,
        pickupDate: pickupDate,
        pickupDateInMS: this.getTimeInMilliSeconds(pickupDate),
        orderDate: check.orderDate,
        openDate: check.openDate,
        orders: check.orders,
        orderTypeId: check.orderTypeId,
        checkName: check.name,
        checkInNote: check.checkInNote,
        unpaidAmount: check.unpaidAmount,
        open: check.open,
        stationId: check.stationId,
        referenceId: check.referenceId,
        taxAmount: check.taxAmount,
        subTotalAmount: check.subTotalAmount,
        totalAmount: check.totalAmount,
        guestName: check.guestName,
        items: check.items,
        tickets: check.tickets,
        slotName: slotName,
        sendDate: sendDate,
      };
    });
    return formattedChecks || [];
  };

  onChangeSmsType = () => {
    this.setState(prevState => ({
      isCustomSmsType: !prevState.isCustomSmsType,
    }));
  };

  getCustomSmsTemplates = () => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    API.getCustomSmsTemplates(storeId)
      .then(response => {
        let { isCustomSmsType, customSmsList } = this.state;
        isCustomSmsType = (response.data && response.data.length > 0) ? true : false;
        customSmsList = response.data || [];
        if (customSmsList && customSmsList.length > 0) {
          this.notifyOrderPrepared = customSmsList.find(each => each.smsTemplate?.smsType === 110) || {};
          this.notifyOrderReady = customSmsList.find(each => each.smsTemplate?.smsType === 112) || {};
        }
        this.setState({ isCustomSmsType, customSmsList });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onHandleSend = (msg, customSmsObj) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi, currencyInfo: { iso2 } } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck, selectedCountry, isCustomSmsType } = this.state;
    const popup = getPopupConfig("error");
    popup.heading = constants.confirmationMessage;
    const phoneNumberForSMS = FireboardUtils.formattedPhoneNumber(selectedCheck?.phoneNumber || '', iso2);
    popup.message = constants.sendSmsPopupMsg;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => {
          this.getPopup('spinner', constants.smdSendLoaderHeading, null);
          const { latitude, longitude } = UTILLib.location;
          let payload = {
            latitude,
            longitude,
            deviceId: deviceId,
            storeId: storeInfo?.data?.id,
            phoneNumber: selectedCheck?.unFormattedPhoneNumber || null,
            countryCode: selectedCountry.dialCode.split('+')[1],
            message: msg,
            checkHeaderId: selectedCheck?.checkHeaderId || selectedCheck?.id,
          };
          if (isCustomSmsType) {
            payload = {
              ...payload,
              custom: true,
              templateId: customSmsObj?.id,
            };
          }
          API.fireboardSendSMS(payload)
            .then((resp) => {
              this.closePopup();
              FireboardUtils.addNetworkLogs(resp);
            })
            .catch((error) => this.handleErrorPopup(error));
        },
      },
    ];
    this.setState({ popup });
  };

  pickedUp = (counter) => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedCheck || {};
    const payload = {
      storeId,
      checkHeaderId,
      counter: counter || false,
    };
    this.getPopup('spinner', 'Marking order as picked up');
    API.orderPickedUp(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshChecks();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  updateOrderStatus = (item, type) => {
    let delivery = false;
    let deliveryVendorName = '';
    let held = false;
    if (item.orders && item.orders.length > 0) {
      delivery = item.orders[0].delivery || false;
      deliveryVendorName = item.orders[0].deliveryVendorName || '';
      held = item.orders[0].held || false;
    }
    let orderStatusId;
    if (type === "done") {
      // TODO: add enums
      orderStatusId = 5;
      this.dispatchOrderStatus(item, orderStatusId);
    } else if (type === "cancel") {
      const popup = getPopupConfig("success");
      popup.heading = constants.orderCancellation;
      popup.message = held
        ? delivery
          ? 'This action will cancel the order immediately. The order delivery will also be canceled at ' + deliveryVendorName + '. If applicable, the order will not be sent to the POS. This action cannot be reversed. Do you want to continue?'
          : constants.cancelHeldOrderMsg
        : delivery
          ? 'Are you sure you want to cancel the order ? This action will ONLY cancel from the Fireboard and ' + deliveryVendorName + '. This action will NOT cancel from the POS and NOT process a refund.'
          : constants.cancelCheckHeadingAlt;
      popup.buttons = [
        {
          text: constants.no,
          onClick: () => {
            this.setState({ popup: undefined });
          },
        },
        {
          text: constants.yes,
          onClick: () => {
            this.cancelOrder(item);
          },
        },
      ];
      this.setState({ popup });
    } else if (type === "moveToInprogress") {
      const popup = getPopupConfig("error");
      popup.heading = constants.futureToIPHeader;
      popup.message = held ? constants.moveHeldOrderMsg : constants.futureToIPMessage;
      popup.buttons = [
        {
          text: constants.noCaps,
          onClick: () => this.setState({ popup: undefined }),
        },
        {
          text: constants.yesCaps,
          onClick: () => {
            orderStatusId = 1;
            this.dispatchOrderStatus(item, orderStatusId);
          },
        },
      ];
      this.setState({ popup });
    }
  };

  cancelOrder = (item) => {
    const orderStatusId = 8;
    this.dispatchOrderStatus(item, orderStatusId, true);
  };

  dispatchOrderStatus = (item, orderStatusId, isCancel) => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    let delivery = false;
    let deliveryVendorName = '';
    if (item.orders && item.orders.length > 0) {
      delivery = item.orders[0].delivery || false;
      deliveryVendorName = item.orders[0].deliveryVendorName || '';
    }
    API.orderStatusUpdate({
      storeId: storeInfo?.data?.id,
      deviceId: deviceId,
      checkHeaderId: item?.id,
      orderStatusId,
    })
      .then((response) => {
        this.state.popup = undefined;
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.refreshChecks();
        if (isCancel) {
          const popup = getPopupConfig("success", () => {
            this.closePopup();
          });
          popup.heading = constants.cancelSuccess;
          popup.message = delivery
            ? 'Order has been cancelled from the Fireboard and ' + deliveryVendorName + '. Please make sure to cancel it on the POS and process a refund from the portal (if applicable)'
            : constants.cancelSuccessMsg;
          this.setState({ popup });
        }
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  markItemAsPaid = item => {
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    this.getPopup("spinner", constants.updateOrderLoading, null);
    API.orderStatusPaid({
      storeId: storeInfo?.data?.id,
      deviceId: deviceId,
      checkHeaderId: item?.id,
    })
      .then((response) => {
        this.state.popup = undefined;
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.refreshChecks();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  notifyOrderStatus = (type) => {
    const { selectedCheck, selectedCountry } = this.state;
    const { checkHeaderId, id, phoneNumber } = selectedCheck;
    const { reduxProps } = this.props;
    const { storeInfo, deviceApi } = reduxProps;
    const { deviceId } = deviceApi?.data;
    const { id: storeId } = storeInfo?.data || {};
    this.getPopup("spinner", type === 'orderBeingPrepared' ? constants.notifyOrderBeingPrepared : constants.notifyOrderReady, null);
    let templateId = type === 'orderBeingPrepared' ? this.notifyOrderPrepared?.id : this.notifyOrderReady?.id;
    const { latitude, longitude } = UTILLib.location;
    let payload = {
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeId,
      phoneNumber: phoneNumber || "",
      countryCode: selectedCountry.dialCode.split('+')[1],
      custom: true,
      templateId: templateId,
      checkHeaderId: checkHeaderId || id,
    };
    API.fireboardSendSMS(payload)
      .then((resp) => {
        this.closePopup();
        FireboardUtils.addNetworkLogs(resp);
      })
      .catch((error) => this.handleErrorPopup(error));
  };

  joinCheck = item => {
    const { sensorData } = this.state;
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const { id: storeId } = storeInfo?.data || {};
    const { stationId } = item || {};
    this.getPopup('spinner', 'Generating QR', null);
    if (sensorData && sensorData.externalId) {
      this.setState({
        popup: {
          type: 'generate-qr-join-check',
          meta: item,
          sensorData: sensorData,
        },
      });
    } else {
      API.sensorCode({
        storeId: storeId,
        stationId: stationId,
      })
        .then((resp) => {
          this.setState({
            sensorData: resp.data,
            popup: {
              type: 'generate-qr-join-check',
              meta: item,
              sensorData: resp.data,
            },
          });
          FireboardUtils.addNetworkLogs(resp);
        })
        .catch((error) => this.handleErrorPopup(error));
    }
  };

  onResyncCheck = item => {
    this.getPopup('spinner', constants.syncingCheck, null);
    API.syncCheck({
      checkHeaderId: item.checkHeaderId,
    })
      .then(response => {
        this.state.popup = undefined;
        this.checks.set(response.data.id, CommonUtil.parseCheckFromRedis(response.data));
        this.refreshChecks();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  invokeTextToPay = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const {
      phoneNumber,
      guestName,
      pickupTime,
      checkNumber,
      subTotal,
      tax,
      selectedCountry,
      preAuth,
    } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck } = this.state;
    const { checkHeaderId } = selectedCheck || {};
    this.getPopup("spinner", constants.textToPayGenLoader, null);
    API.generateTextToPay({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo?.data?.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +subTotal,
      taxAmount: +tax,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId,
      preAuth: preAuth || false,
    })
      .then((response) => {
        this.state.popup = undefined;
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.refreshChecks();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: () => this.closePopup(),
          },
          {
            text: constants.retry,
            onClick: () => this.invokeTextToPay(payload),
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  invokeCheckIn = (payload) => {
    const { latitude, longitude } = UTILLib.location;
    const { phoneNumber, guestName, pickupTime, checkNumber, selectedCountry, } = payload;
    const {
      reduxProps: { storeInfo, deviceApi },
    } = this.props;
    const { deviceId } = deviceApi?.data;
    const { selectedCheck } = this.state;
    const { checkHeaderId } = selectedCheck || {};
    this.getPopup("spinner", constants.checkInRequestLoader, null);
    API.checkInRequest({
      latitude,
      longitude,
      deviceId: deviceId,
      storeId: storeInfo?.data?.id,
      guestName,
      phoneNumber: FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry.iso2),
      checkNumber,
      subtotalAmount: +0,
      taxAmount: +0,
      pickupTime: pickupTime,
      countryCode: selectedCountry.dialCode.split('+')[1],
      checkHeaderId,
    })
      .then((response) => {
        this.state.popup = undefined;
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.refreshChecks();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch((error) => {
        const errorPopup = getPopupConfig("error");
        errorPopup.message = error.response
          ? error.response.data
          : error.message;
        EventEmitter.addLogs(
          'appLogs',
          LogLevelEnum.ERROR,
          `${errorPopup.message} checkNumber is ${checkNumber}`
        );
        FireboardUtils.addNetworkLogs(error.response);
        errorPopup.buttons = [
          {
            text: constants.cancelText,
            onClick: () => this.closePopup(),
          },
          {
            text: constants.retry,
            onClick: () => this.invokeCheckIn(payload),
          },
        ];
        this.setState({ popup: errorPopup });
      });
  };

  rePostPayment = ticket => {
    const { reduxProps, dispatchRetryPOS } = this.props;
    const { storeInfo, deviceApi } = reduxProps || {};
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data;
    const payload = {
      employeeId: null,
      storeId,
      deviceId,
      employeeCard: null,
      ticketId: ticket?.ticketId,
      checkTicketId: ticket?.id,
    };
    dispatchRetryPOS && dispatchRetryPOS(payload);
  };

  handleRetryPOSPayment = reduxProps => {
    const { reduxProps: prevReduxProps } = this.props;
    if (reduxProps.retryPOSPayment.timestamp !== prevReduxProps.retryPOSPayment.timestamp) {
      if (reduxProps.retryPOSPayment.data) {
        const popup = getPopupConfig('success');
        this.setState({ popup });
      } else if (reduxProps.retryPOSPayment.error) {
        const popup = getPopupConfig('error', () => {
          this.setState({ popup: undefined });
        });
        popup.message = reduxProps.retryPOSPayment.error;
        this.setState({ popup });
      } else if (reduxProps.retryPOSPayment.isFetching) {
        const popup = getPopupConfig('spinner');
        popup.heading = 'Posting Payment';
        this.setState({ popup });
      }
    }
  };

  onRedeemVoucher = (type, data) => {
    if (type === 'scanToRedeem' && window.ReactNativeWebView) {
      EventEmitter.scanQRCodeToRedeem('scanToRedeem');
    } else if (type === 'redeemCode') {
      const { first, last } = data || {};
      this.showRedeemConfirmation({
        voucherCodeTextFirst4: first,
        voucherCodeTextLast4: last,
      });
    } else if (type === 'managerOverride') {
      const { employeeCode } = data || {};
      this.showRedeemConfirmation({
        employeeCode: employeeCode,
      });
    }
  };

  onVoucherScanned = qrCode => {
    this.showRedeemConfirmation({
      voucherQrCode: qrCode,
    });
  };

  showRedeemConfirmation = payload => {
    const callback = () => {
      const { selectedCheck } = this.state;
      const { id: checkHeaderId } = selectedCheck || {};
      const { reduxProps: { storeInfo, deviceApi } } = this.props;
      const { id: storeId } = storeInfo?.data || {};
      const { deviceId } = deviceApi?.data;
      const newPayload = {
        ...payload,
        storeId,
        deviceId,
        checkHeaderId,
      };
      this.getPopup('spinner', 'Applying Voucher', null);
      API.voucherCheckIn(newPayload)
        .then(response => {
          this.state.popup = undefined;
          const newCheck = response.data;
          this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
          this.refreshChecks();
          FireboardUtils.addNetworkLogs(response);
        })
        .catch((error) => this.handleErrorPopup(error));
    };

    const oldPopup = this.state.popup;
    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = 'This will redeem the voucher and send any items to the kitchen. This action cannot be undone. Do you want to continue?';
    popup.buttons = [
      {
        text: 'No',
        onClick: () => this.setState({ popup: oldPopup })
      },
      {
        text: 'Yes',
        onClick: () => {
          callback && callback();
        },
      }
    ];
    this.setState({ popup });
  };

  generateQR = item => {
    this.setState({
      popup: {
        type: 'generate-qr',
        meta: item,
      },
    });
  };

  onHandleTextToPay = (item, fromFooter) => {
    this.setState({ popup: { type: "textToPay", meta: item }, fromFooter });
  };

  textToCheckIn = (item, fromFooter) => {
    this.setState({ popup: { type: "checkIn", meta: item }, fromFooter });
  };

  openPaymentHistory = () => this.showPopup('repostpayment');

  onPressRedeemVoucher = () => this.showPopup('redeemCheckVoucher');

  onRequestRefreshGuestGPS = () => {
    const oldPopup = this.state.popup;

    const callback = () => {
      this.getPopup('spinner', 'Sending SMS to request guest location');
      const { checkHeaderId } = this.state?.selectedCheck || {};
      API.textToGetLocation(checkHeaderId)
        .then(response => {
          this.setState({ popup: oldPopup })
          FireboardUtils.addNetworkLogs(response);
        })
        .catch(error => this.handleErrorPopup(error));
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = 'This will send a text message to the guest requesting their location. Do you want to continue?';
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.setState({ popup: oldPopup }),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  onOrderDelivered = check => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = check || {};
    const payload = {
      storeId,
      checkHeaderId
    };
    this.getPopup('spinner', "Marking order as delivered");
    API.gpsLocationPickedUp(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshChecks();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onFooterButtonPress = (actionTypes, check) => {
    this.state.selectedCheck = check;
    switch (actionTypes) {
      case 'notify':
        this.showPopup('sms');
        break;
      case 'inProgress':
        this.updateOrderStatus(check, 'moveToInprogress');
        break;
      case 'seeCounter':
        this.pickedUp(true);
        break;
      case 'complete':
        this.updateOrderStatus(check, 'done');
        break;
      case 'pickedUp':
        this.pickedUp(false);
        break;
      case 'manageCubby':
        this.onPressManageCubby();
        break;
      default:
        console.warn(`footer action - ${actionTypes} is not handled!!!`);
    }
  };

  onPressManageCubby = () => {
    const { selectedCheck } = this.state;
    const [order0] = selectedCheck?.orders || [];
    const { storeCubbySlotId } = order0 || {};
    if (!storeCubbySlotId) {
      this.cubbyLayoutPopupType = 'Assign';
      this.setState({ popup: { type: 'cubbyLayout' } });
    } else {
      this.setState({ popup: { type: 'cubbyMenu' } });
    }
  };

  onMoveSlotOrder = selectedSlots => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId } = this.state?.selectedCheck || {};
    const slotIds = [...selectedSlots.keys()];
    const slotId = slotIds[0];
    const slots = [...selectedSlots.values()];
    const [slot0] = slots || []
    const slotName = slot0?.name || '';
    const payload = {
      storeId,
      checkHeaderId,
      storeCubbySlotId: slotId
    };
    const spinnerMsg = this.cubbyLayoutPopupType === 'Assign' ? 'Assigning slot' : 'Moving order';
    const toastMsg = this.cubbyLayoutPopupType === 'Assign' ? `Slot ${slotName} is assigned` : `Order is moved to slot ${slotName}`;
    this.callCubbyAssignApi(payload, spinnerMsg, toastMsg);
  };

  clearSlot = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { checkHeaderId, orders } = this.state?.selectedCheck || {};
    const [order0] = orders || [];
    const slot = this.storeCubbySlotsMap.has(order0?.storeCubbySlotId) ? this.storeCubbySlotsMap.get(order0?.storeCubbySlotId) : {};
    const slotName = slot?.name || '';

    const callback = () => {
      const payload = {
        storeId,
        checkHeaderId,
        storeCubbySlotId: null
      };
      this.callCubbyAssignApi(payload, 'Clearing slot', `Slot ${slotName} is cleared`);
    };

    const popup = getPopupConfig('error');
    popup.heading = 'Confirmation';
    popup.message = `This will clear the order from slot ${slotName}. Do you want to continue?`;
    popup.buttons = [
      {
        text: constants.no,
        onClick: () => this.closePopup(),
      },
      {
        text: constants.yes,
        onClick: () => callback && callback(),
      },
    ];
    this.setState({ popup });
  };

  callCubbyAssignApi = (payload, spinnerMsg, toastMsg) => {
    this.getPopup('spinner', spinnerMsg);
    API.cubbyAssign(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshChecks();
        toast.success(toastMsg, { autoClose: 1000 });
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onCubbyMenuPress = type => {
    switch (type) {
      case 'moveFromSlot':
        this.cubbyLayoutPopupType = 'Move';
        this.setState({ popup: { type: 'cubbyLayout' } });
        break;
      case 'clearFromSlot':
        this.clearSlot();
        break;
      case 'pickedUp':
        this.pickedUp(false);
        break;
      default:
        console.warn('case not handled!!!');
        break;
    }
  };

  pad = (value) => {
    let str = String(value);
    let size = 10;
    while (size > 0) {
      str = '0' + str;
      size--;
    }
    return str;
  };

  sortChecksByTime = (a, b) => {
    const time1 = a.pickupDateInMS;
    const time2 = b.pickupDateInMS;
    return time1 - time2;
  };

  sortChecksByName = (a, b) => {
    const deliverTo1 = this.pad(a.deliverTo ? a.deliverTo : '').toLowerCase();
    const deliverTo2 = this.pad(b.deliverTo ? b.deliverTo : '').toLowerCase();
    if (deliverTo1 < deliverTo2)
      return -1;
    if (deliverTo1 > deliverTo2)
      return 1;
    return 0;
  };

  onChangeSortBy = () => {
    this.setState(prevState => ({ sortByTime: !prevState.sortByTime }));
  };

  onUpdateGuestInformation = guestInfo => {
    const { reduxProps: { storeInfo } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId } = selectedCheck || {};
    const payload = {
      storeId,
      checkHeaderId,
      ...guestInfo,
    };
    this.getPopup('spinner', "Updating guest information");
    API.updateGuestInformation(payload)
      .then(response => {
        const newCheck = response.data;
        this.checks.set(newCheck.id, CommonUtil.parseCheckFromRedis(newCheck));
        this.closePopup();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAsSeeCounter = () => {
    this.pickedUp(true);
  };

  buildSensorsHashTable = () => {
    const { reduxProps: { storeInfo } } = this.props;
    const { sensors } = storeInfo?.data || {};
    this.sensorsMap = FireboardUtils.buildSensorsHashTable(sensors);
  };

  onUpdateAgeRestrictedItemsForCheck = () => {
    this.setState({
      popup: {
        type: 'login',
        metaData: { indentifier: checkEnum.AGE_RESTRICTED_FOR_CHECK }
      }
    });
  }

  invokeAgeRestrictedItemsForCheck = (employeeId) => {
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId, orders } = selectedCheck || {};
    const [order0] = orders || [];
    const { disableAgeRestricted } = order0 || {};
    const payload = {
      storeId,
      deviceId,
      checkHeaderId,
      employeeId: employeeId || null,
      disableAgeRestricted: !disableAgeRestricted,
    };
    const spinnerMsg = disableAgeRestricted
      ? constants.enablingAgeRestrictedItems
      : constants.disablingAgeRestrictedItems;
    this.getPopup('spinner', spinnerMsg, null);
    API.ageRestrictedItemsUpdateForCheck(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshChecks();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  onLogin = (loginId, indentifier) => {
    const { reduxProps: { deviceApi, deviceApiData } } = this.props;
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const payload = {
      deviceId: deviceId,
      appVersion: version,
      employeeCode: loginId,
      employeeCard: null,
      jobId: null,
      manager: false,
    };
    this.getPopup('spinner', constants.loginLoadingHeading, null);
    API.login(payload, true)
      .then(response => {
        const { id: employeeId } = response.data;
        if (indentifier === checkEnum.ID_CHECK) {
          this.onMarkAsAgeVerified(employeeId);
        } else if (indentifier === checkEnum.AGE_RESTRICTED_FOR_CHECK) {
          this.invokeAgeRestrictedItemsForCheck(employeeId);
        } else {
          this.setState({ popup: undefined });
        }
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  markAsAgeVerified = () => {
    this.setState({
      popup: {
        type: 'login',
        metaData: { indentifier: checkEnum.ID_CHECK }
      }
    });
  };

  onMarkAsAgeVerified = (employeeId) => {
    const { reduxProps: { storeInfo, deviceApi, deviceApiData } } = this.props;
    const { id: storeId } = storeInfo?.data || {};
    const { deviceId } = deviceApi?.data || deviceApiData || {};
    const { selectedCheck } = this.state;
    const { id: checkHeaderId, orders } = selectedCheck || {};
    const [order0] = orders || [];
    const { ageVerificationStatus } = order0 || {};
    const payload = {
      storeId,
      deviceId: deviceId,
      employeeId: employeeId || null,
      checkHeaderId,
      confirmIdCheck: ageVerificationStatus === 5 ? false : true,
    };
    const spinnerMsg = ageVerificationStatus === 5 ? constants.clearingIdCheck : constants.confirmingIdCheck;
    this.getPopup('spinner', spinnerMsg, null);
    API.ageVerification(payload)
      .then(response => {
        this.state.popup = undefined;
        const updatedCheck = response.data;
        this.checks.set(updatedCheck.id, CommonUtil.parseCheckFromRedis(updatedCheck));
        this.refreshChecks();
        FireboardUtils.addNetworkLogs(response);
      })
      .catch(error => this.handleErrorPopup(error));
  };

  get viewProps() {
    const {
      popup,
      check,
      isCustomSmsType,
      customSmsList,
      selectedCheck,
      isDevEnvironment,
      fromFooter,
      pendingCheckList,
      comingUpCheckList,
      inProgressCheckList,
      completeCheckList,
      seeCounterCheckList,
      twoDimensionSlot,
      sortByTime,
    } = this.state;
    const { reduxProps: { storeInfo, currencyInfo, deviceApi, deviceApiData } } = this.props || {};
    const { iso2 } = currencyInfo || {};
    const { deviceGroup } = deviceApi?.data || deviceApiData || {};

    const checkSortFunc = sortByTime ? this.sortChecksByTime : this.sortChecksByName;
    const sortedPendingChecks = pendingCheckList.sort(checkSortFunc);
    const sortedComingUpChecks = comingUpCheckList.sort(checkSortFunc);
    const sortedInProgressChecks = inProgressCheckList.sort(checkSortFunc);
    const sortedCompleteChecks = completeCheckList.sort(checkSortFunc);
    const sortedSeeCounterChecks = seeCounterCheckList.sort(checkSortFunc);

    return {
      popup,
      check,
      parentRoute: this.parentRoute,
      iso2,
      currency: this.currency,
      isCustomSmsType,
      customSmsList,
      storeInfo: storeInfo.data,
      selectedCheck,
      isDevEnvironment,
      notifyOrderPrepared: this.notifyOrderPrepared,
      notifyOrderReady: this.notifyOrderReady,
      fromFooter,
      deviceGroup,
      pendingCheckList: sortedPendingChecks,
      comingUpCheckList: sortedComingUpChecks,
      inProgressCheckList: sortedInProgressChecks,
      completeCheckList: sortedCompleteChecks,
      seeCounterCheckList: sortedSeeCounterChecks,
      twoDimensionSlot,
      cubbyLayoutPopupType: this.cubbyLayoutPopupType,
      sortByTime,
      enableAgeRestrictedOrderingForCheck: this.enableAgeRestrictedOrderingForCheck,
      enableAgeVerification: this.enableAgeVerification,
      closePopup: this.closePopup,
      showPopup: this.showPopup,
      goBack: this.goBack,
      onChangeSmsType: this.onChangeSmsType,
      onHandleSend: this.onHandleSend,
      updateOrderStatus: this.updateOrderStatus,
      onHandleTextToPay: this.onHandleTextToPay,
      textToCheckIn: this.textToCheckIn,
      notifyOrderStatus: this.notifyOrderStatus,
      onResyncCheck: this.onResyncCheck,
      joinCheck: this.joinCheck,
      markItemAsPaid: this.markItemAsPaid,
      invokeTextToPay: this.invokeTextToPay,
      invokeCheckIn: this.invokeCheckIn,
      onQRGenerate: this.generateQR,
      openPaymentHistory: this.openPaymentHistory,
      rePostPayment: this.rePostPayment,
      onPressRedeemVoucher: this.onPressRedeemVoucher,
      onRedeemVoucher: this.onRedeemVoucher,
      onRequestRefreshGuestGPS: this.onRequestRefreshGuestGPS,
      onOrderDelivered: this.onOrderDelivered,
      onFooterButtonPress: this.onFooterButtonPress,
      onCubbyMenuPress: this.onCubbyMenuPress,
      onMoveSlotOrder: this.onMoveSlotOrder,
      onChangeSortBy: this.onChangeSortBy,
      onUpdateGuestInformation: this.onUpdateGuestInformation,
      markAsSeeCounter: this.markAsSeeCounter,
      onUpdateAgeRestrictedItemsForCheck: this.onUpdateAgeRestrictedItemsForCheck,
      markAsAgeVerified: this.markAsAgeVerified,
      onLogin: this.onLogin,
    };
  };

  render() {
    const viewProps = this.viewProps;
    return <View {...viewProps} />;
  }
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchRetryPOS: (payload) => {
    dispatch(retryPOSPayment(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withSocketContext(OrderStatusManager));
